<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :title="$t('SshKeyManagement_Dialog_CreateTitle')"
    :before-close="onClose"
    width="600px"
    center
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('SshKeyManagement_Field_Name')" prop="name">
        <el-input
          v-model="form.name"
          :placeholder="$t('SshKeyManagement_Field_Name_Placeholder')"
        />
        <div v-if="showHint" class="field-hint">
          {{ $t('Integrations_Sftp_Field_SshKeyNameDescription') }}
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('SshKeyManagement_Field_KeyType')"
        prop="key_type"
      >
        <el-select v-model="form.key_type" style="width: 100%">
          <el-option
            v-for="option in allowedKeyTypeOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="generate" :loading="loading">
        {{ $t('SshKeyManagement_Button_Generate') }}
        <i class="el-icon-key"></i>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import sshKeyTypesMixin from '@/common/mixins/sshKeyTypesMixin'

export default {
  name: 'SshKeyGenerateDialog',

  mixins: [sshKeyTypesMixin],

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    showHint: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      form: {
        name: '',
        key_type: ''
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t('RestForm_FieldIsRequired'),
            trigger: 'blur'
          }
        ]
      }
    }
  },

  mounted() {
    this.fetchKeyTypes().then(() => {
      this.form.key_type = this.defaultKeyType
    })
  },

  methods: {
    generate() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        this.loading = true
        RestApi.post(`projects/${this.$store.getters.projectId}/ssh-keys`, {
          name: this.form.name,
          generate: 1,
          key_type: this.form.key_type
        })
          .then(({ data }) => {
            this.$emit('created', data)
            this.reset()
            this.onClose()
          })
          .catch(error => {
            this.$message({
              message: this.formatErrorMessage(error),
              type: 'error',
              dangerouslyUseHTMLString: true
            })
          })
          .finally(() => {
            this.loading = false
          })
      })
    },

    formatErrorMessage(error) {
      const errors =
        error.response && error.response.data && error.response.data.errors
      if (errors && typeof errors === 'object') {
        const fieldErrors = Object.values(errors)
          .flat()
          .map(msg => `&nbsp;&nbsp;• ${msg.replace(/^\w+__/, '')}`)
          .join('<br>')
        if (error.message && fieldErrors) {
          return `${error.message}<br>${fieldErrors}`
        }
        return fieldErrors || error.message
      }
      return error.message
    },

    reset() {
      this.form.name = ''
      this.form.key_type = this.defaultKeyType
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },

    onClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.field-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ssh/SshKeyGenerateDialog.vue